import { CDElement } from "./CDElement";
import { AutoDataPrefixer } from "../dom-tools/AutoDataPrefixer";
import { ScopeResolver } from "../dom-tools/ScopeResolver";
import { CDMediaQuery } from "./CDMediaQuery";

export class CDSelector extends CDElement 
{
  private _rawSelector:string;
  private _selector:string;
  private _combinedScope:string;


  constructor( selector:string ) 
  {
    super( CDElement.CDSelectorType );
    this._rawSelector = selector;
    this._selector = AutoDataPrefixer.apply( selector );
    this.setAttribute( "raw-selector", selector );
    this.setAttribute( "selector", selector );
  }

  get selector() 
  {
    return this._selector;
  }

  get rawSelector() 
  {
    return this._rawSelector;
  }
  
  get selectorScope() 
  {
    if ( !this._combinedScope ) 
    {
      this._getCombinedScope();
    }

    return this._combinedScope;
  }

  get mediaQuery()
  {
    let it = this.parent;

    while ( it !== null ) 
    {
      if ( CDElement.CDMediaQueryType === it.type ) 
      {
        return it as CDMediaQuery;
      }

      it = it.parent;
    }

    return null;
  }

  _getCombinedScope() 
  {
    if ( this.hasInheritedScope ) 
    {
      let scope = this.selector;
      let parentScope = this._getParentScope();
      this._combinedScope = ScopeResolver.inheritScopes( parentScope, scope );
    }
    else
    {
      this._combinedScope = this.selector;
    }
  }

  get hasInheritedScope( ) 
  {
    return /&/.test( this._rawSelector );
  }

  get isHTMLCreationChild( ) 
  {
    return /&&/.test( this._rawSelector );
  }

  _getParentScope( ) 
  {
    let parent = this.parent;

    while ( parent !== null ) 
    {
      if ( CDElement.CDSelectorType === parent.type ) 
      {
        return parent.selectorScope;
      }

      parent = parent.parent;
    }

    return null;
  }
}